import type { ConsentStatus } from './consent';
import type { PatientLinkStatus } from './links';

/**
 * Live alerts sent over Socket.io. They carry IDs and states only, never
 * content. The app fetches what an alert points at through the API.
 *
 * practice: something about this practice changed for the recipient, such as
 * its status, its members, an invitation or a pharmacy link. Fetch it again.
 * patient_link: a link between a patient and this practice was asked for,
 * made, declined or removed. Sent to the patient and to the practice's
 * doctors and front desk.
 */
export type Alert =
  | { type: 'envelope'; envelopeId: string; deviceId: string }
  | { type: 'consent'; consentId: string; status: ConsentStatus }
  | { type: 'practice'; practiceId: string }
  | { type: 'patient_link'; linkId: string; practiceId: string; status: PatientLinkStatus };

/** The Socket.io event name for alerts. */
export const ALERT_EVENT = 'alert';
